// Rechargement automatique quand une NOUVELLE version de l'app est déployée —
// pour ne plus avoir à demander aux utilisateurs (livreurs, staff) de rafraîchir
// à la main après chaque mise en production.
//
// Principe : le build CRA publie `asset-manifest.json` avec le nom haché du
// bundle principal (main.<hash>.js), qui change à chaque déploiement. On mémorise
// le hash chargé au démarrage, puis on recompare AU RETOUR sur l'onglet
// (visibilité/focus — le moment le moins perturbant, sans couper une saisie en
// cours). Si le hash a changé, on recharge. Aucun rechargement pendant que
// l'utilisateur est actif sur la page.

let current = null;

const mainHash = (m) => (m && (m['main.js'] || (m.files && m.files['main.js']))) || null;

const check = async ({ reloadOnChange } = {}) => {
  try {
    const res = await fetch('/asset-manifest.json', { cache: 'no-store' });
    if (!res.ok) return;
    const manifest = await res.json();
    const main = mainHash(manifest);
    if (!main) return;
    if (current === null) { current = main; return; }   // 1er passage : mémorise la version courante
    if (main !== current) {
      current = main;
      if (reloadOnChange && typeof window !== 'undefined') window.location.reload();
    }
  } catch (e) { /* hors-ligne / erreur réseau : on ignore silencieusement */ }
};

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  check(); // mémorise la version au chargement
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check({ reloadOnChange: true });
  });
  window.addEventListener('focus', () => check({ reloadOnChange: true }));
}

export default check;
